import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { fromJSX } from 'widgets-for-react';
import { PanoramaLayout } from './PanoramaLayout';
export const PanoramaBlock = (props)=>{
    return fromJSX(()=>/*#__PURE__*/ _jsx(PanoramaLayout, {
            ...props
        })).run(()=>{});
};
